import { Editor } from '@tinymce/tinymce-react';

// TinyMCE so the global var exists
import 'tinymce/tinymce';
// DOM model
import 'tinymce/models/dom/model';
// Theme
import 'tinymce/themes/silver';
// Toolbar icons
import 'tinymce/icons/default';
import 'tinymce/skins/ui/oxide/skin';

// importing the plugin js.
// if you use a plugin that is not listed here the editor will fail to load
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/link';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/help';
import 'tinymce/plugins/help/js/i18n/keynav/en';
import 'tinymce/plugins/importcss';
import 'tinymce/plugins/lists';

// Content styles, including inline UI like fake cursors
import 'tinymce/skins/ui/oxide/content.css';
import { useState } from 'react';
import { LoadingIndicator } from '#lib/components/loading.jsx';
import { cn } from '#lib/helpers/class.js';

export default function HTMLEditor(props) {
    const { value, disabled, onEditorChange } = props;
    const [isLoading, setIsLoading] = useState(true);
    return (
        <div className={cn('relative w-full overflow-hidden', isLoading && 'h-48')}>
            <Editor
                licenseKey="gpl"
                init={{
                    min_height: props?.height || 0,
                    plugins: 'link anchor lists advlist autoresize paste',
                    paste_preprocess: function (_, data) {
                        const allowed = ['br', 'ul', 'ol', 'li', 'b', 'i', 'u', 's', 'p', 'strong', 'em', 'a'];
                        data.content = data.content.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi, (match, tag) => {
                            return allowed.includes(tag.toLowerCase()) ? match : '';
                        });
                    },
                    toolbar:
                        'link | undo redo | bold italic underline strikethrough | fontfamily fontsize alignleft aligncenter alignright alignjustify bullist numlist outdent indent ',
                    menubar: false,
                    menu: {
                        edit: { title: 'Edit', items: 'undo redo | selectall' }
                    },
                    forced_root_block: 'p',
                    content_style: `
            body { font-family:Helvetica,Arial,sans-serif; font-size:14px }
            p, li { margin-bottom: 0.5em; }
            div, p { text-align: left !important; }
        `
                }}
                onInit={() => {
                    setIsLoading(false);
                }}
                onEditorChange={onEditorChange}
                value={value}
                disabled={!!disabled}
            />
            {isLoading && (
                <div className="absolute top-0 left-0 flex items-center justify-center w-full h-full bg-white">
                    <LoadingIndicator />
                </div>
            )}
        </div>
    );
}
